import { handleException } from 'actions/exceptions';
import { ApiService } from 'services';

export const SEARCH_BATCH_FORMS_REQUEST = 'SEARCH_BATCH_FORMS_REQUEST';
export const SEARCH_BATCH_FORMS_SUCCESS = 'SEARCH_BATCH_FORMS_SUCCESS';
export const SEARCH_BATCH_FORMS_FAILURE = 'SEARCH_BATCH_FORMS_FAILURE';

function requestSearchBatchForms() {
  return {
    type: SEARCH_BATCH_FORMS_REQUEST,
    isGettingBatchForms: true
  };
}

function receiveSearchBatchForms(batchForms, batchFormsCount) {
  return {
    type: SEARCH_BATCH_FORMS_SUCCESS,
    isGettingBatchForms: false,
    batchForms,
    batchFormsCount
  };
}

function rejectSearchBatchForms() {
  return {
    type: SEARCH_BATCH_FORMS_FAILURE,
    isGettingBatchForms: false
  };
}

export function searchBatchForms(batchId, batchFileId, pageNumber, pageSize, sortBy, sortDirection, filters, searchQuery) {
  return (dispatch) => {
    dispatch(requestSearchBatchForms());
    const promise = () => ApiService
      .searchBatchForms(batchId, batchFileId, pageNumber, pageSize, sortBy, sortDirection, filters, searchQuery)
      .then((response) => {
        dispatch(receiveSearchBatchForms(response.data.batchForms, response.data.totalCount));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectSearchBatchForms, true));
        }
      });
    return promise();
  };
}
